import React from "react"
import { Link } from "gatsby"
import '../styles/global.css';

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

import image1 from '../images/image1.png'
import image2 from '../images/image2.png'
import image3 from '../images/image3.png'
import image4 from '../images/image4.png'
import image5 from '../images/image5.png'

const IndexPage = () => (
  <Layout>
    <SEO title="" />
    <section className="px-8 text-left w-screen my-56">
      <h1 className="text-7xl text-white md:text-10xl md:text-center">Johzeef</h1>
      <h2 className="text-4xl md:text-5xl text-black mt-3 md:mt-6 md:text-center ">I make things</h2>
      <div className="flex md:justify-center">
      <a href="https://twitter.com/johzeef" className="text-center text-2xl md:text-4xl mt-20 bg-white py-4 px-16 b-stroke"> FOLLOW ME </a>
      </div>
    </section>"
    <section className="section bg-white px-8">
      <div className="flex items-center">
        <h1 className="text-4xl w-screen -mt-4 md:-mt-9 md:text-7xl text-black text-center">What I'm Doing</h1>
      </div>

      <div id="doing" className="flex flex-col md:flex-row space-y-16 md:space-y-0 py-20 md:flex-wrap">
        <div className="md:w-1/3 md:py-16 md:px-8">
          <img src={image1} className="" />
          <div className="b-stroke text-left text-lg mt-3 p-3">
            Indie GAMES: BACKGROUND MUSIC AND SOUNDTRACKS
          </div>
        </div>
        <div className="md:w-1/3 md:py-16 md:px-8">
          <img src={image2} className="" />
          <div className="b-stroke text-left text-lg mt-3 p-3">
            BANDCAMP: <a href="https://johzeef.bandcamp.com/releases">LINK</a>
          </div>

        </div>
        <div className="md:w-1/3 md:py-16 md:px-8">
          <img src={image3} className="" />
          <div className="b-stroke text-left text-lg mt-3 p-3">
          Twitter: <a href="https://www.twitter.com/johzeef">link</a>
          </div>

        </div>
        <div className="md:w-1/3 md:py-16 md:px-8">
          <img src={image4} className="" />
          <div className="b-stroke text-left text-lg mt-3 p-3">
          Youtube: <a href="https://www.youtube.com/channel/UC2miLQCQ-3ukjmt7uITUKhw?view_as=subscriber">link</a>
          </div>

        </div>
        <div className="md:w-1/3 md:py-16 md:px-8">
          <img src={image5} className="" />
          <div className="b-stroke text-left text-lg mt-3 p-3">
          TWITCH: <a href="https://www.twitch.tv/johzeef">link</a>
          </div>

        </div>

      </div>
    </section>
  </Layout>
)

export default IndexPage
